import classNames from 'classnames';
import React from 'react';
import type { RCAvatarProps } from '../../RCAvatar/RCAvatar';

export interface LinkElementProps {
  className?: string;
  children?: React.ReactNode;
}

interface RCFavoriteCardProps {
  additionalContent: React.ReactElement;
  primaryAction?: React.ReactElement;
  secondaryAction?: React.ReactElement;
  subtitle: string;
  avatar?: React.ReactElement<RCAvatarProps>;
  thumbnailURL?: string;
  title: string;
  type?: 'search' | 'shop';
  linkElement: (children: React.ReactNode) => React.ReactElement<LinkElementProps>;
  verticalStretch: boolean;
}

export function RCFavoriteCard({
  additionalContent,
  primaryAction = undefined,
  secondaryAction = undefined,
  subtitle,
  avatar = undefined,
  title,
  type = 'search',
  thumbnailURL = '',
  linkElement,
  verticalStretch = false,
}: RCFavoriteCardProps) {
  function PassedLink({ children, className }: LinkElementProps) {
    return React.cloneElement(
      linkElement(children),
      { className: className },
    );
  }

  function Thumbnail() {
    if (type === 'shop' && avatar) {
      return avatar;
    }

    if (type === 'search' && thumbnailURL) {
      return (
        <img
          className="rc-favorite-card__thumbnail-image"
          src={thumbnailURL}
          alt=""
        />
      );
    }

    return null;
  }

  return (
    <div className={classNames(
      'rc-favorite-card',
      {
        'rc-favorite-card--shop': type === 'shop',
        'rc-favorite-card--search': type === 'search',
        'rc-favorite-card--stretch': verticalStretch,
        'rc-favorite-card--double-action': primaryAction && secondaryAction,
        'rc-favorite-card--single-action': primaryAction || secondaryAction,
        'rc-favorite-card--clickable': linkElement,
      },
    )}>
      <div className="rc-favorite-card__primary-content">
        <div className="rc-favorite-card__thumbnail">
          <PassedLink className="rc-favorite-card__thumbnail-link">
            <Thumbnail />
          </PassedLink>
        </div>
        <div className="rc-favorite-card__titleblock">
          <PassedLink className="rc-favorite-card__title">
            {title}
          </PassedLink>
          {subtitle &&
            <span className="rc-favorite-card__subtitle">
              {subtitle}
            </span>
          }
        </div>
      </div>
      <div className="rc-favorite-card__secondary-content">
        <div className="rc-favorite-card__additional">
          {additionalContent}
        </div>
        {(primaryAction || secondaryAction) &&
          <div className="rc-favorite-card__actions">
            {primaryAction &&
              <div className="rc-favorite-card__action rc-favorite-card__action--primary">
                {primaryAction}
              </div>
            }
            {secondaryAction &&
              <div className="rc-favorite-card__action rc-favorite-card__action--secondary">
                {secondaryAction}
              </div>
            }
          </div>
        }
      </div>
    </div>
  );
}
